export const en = {
  // Navigation
  nav: {
    dashboard: "Dashboard",
    nutrition: "Nutrition",
    workouts: "Workouts",
    progress: "Progress",
    analytics: "Analytics",
    ranking: "Ranking",
    social: "Social",
    report: "Report",
    help: "Help",
    timer: "Timer",
    pricing: "Plans",
    profile: "Profile",
    logout: "Log out",
    login: "Log in",
    signup: "Sign up",
    home: "Home",
    macros: "Macros",
    more: "More",
    moreOptions: "More options",
  },
  // Dashboard
  dashboard: {
    welcome: "Hello, {{name}}! 👋",
    welcomeGeneric: "Hello! 👋",
    subtitle: "Here's your daily summary",
    waterTracker: "Water",
    streak: "Streak",
    gamification: "Points",
    dailyCheckin: "Daily Check-in",
    microGoals: "Micro Goals",
    weeklySummary: "Weekly Summary",
    aiInsights: "AI Insights",
    weeklyChallenges: "Weekly Challenges",
    calorieCounter: "Calories",
    features: "Features",
  },
  // Common
  common: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    generate: "Generate",
    start: "Start",
    stop: "Stop",
    pause: "Pause",
    reset: "Reset",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    or: "or",
    and: "and",
    of: "of",
    to: "to",
    from: "from",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
    points: "points",
    total: "total",
    average: "average",
    noData: "No data",
    error: "Error",
    success: "Success",
    share: "Share",
    download: "Download",
    copy: "Copy",
    copied: "Copied!",
    optional: "optional",
    required: "required",
    add: "Add",
    remove: "Remove",
    saving: "Saving...",
    updating: "Updating...",
    generating: "Generating...",
    sending: "Sending...",
    searching: "Searching...",
  },
  // Timer
  timer: {
    title: "Workout Timer",
    subtitle: "Stopwatch, countdown, intervals and circuits",
    intervals: "Intervals",
    circuit: "Circuit",
    countdown: "Countdown",
    stopwatch: "Stopwatch",
    work: "Work",
    rest: "Rest",
    rounds: "Rounds",
    round: "Round",
    done: "Done!",
    readyToStart: "Ready to start",
    laps: "Laps",
    lap: "Lap",
    timeUp: "Time's up!",
    startCircuit: "Start Circuit",
    restart: "Restart",
    exerciseName: "Exercise name",
    addExercise: "Add Exercise",
    restBetween: "Rest (s)",
    restBetweenRounds: "Round Rest (s)",
    totalEstimate: "total",
  },
  // Nutrition
  nutrition: {
    title: "AI Meal Plan",
    subtitle: "Personalized meal plans generated by AI",
    generateNew: "Generate New Plan",
    generating: "Generating plan...",
    noPlans: "No plans created yet",
    noPlansDesc: "Click 'Generate New Plan' above to create your first personalized AI meal plan",
    weightRequired: "Weight required",
    seeRecipe: "See Recipe",
    ingredients: "Ingredients",
    instructions: "How to Prepare",
    prepTime: "Prep time",
    difficulty: "Difficulty",
    easy: "easy",
    medium: "medium",
    hard: "hard",
    planName: "Plan name (optional)",
    planNamePlaceholder: "E.g.: Low Carb Diet...",
  },
  // Workouts
  workouts: {
    title: "AI Workout Plan",
    subtitle: "Personalized workouts generated by AI",
    generateNew: "Generate New Plan",
    generating: "Generating plan...",
    noPlans: "No plans created yet",
    planName: "Plan name (optional)",
    planNamePlaceholder: "E.g.: Upper/Lower Split...",
    workoutComplete: "✓ Workout Complete",
    markWorkoutComplete: "Mark workout as complete",
  },
  // Progress
  progress: {
    title: "Your Progress",
    subtitle: "Track your physical evolution",
    addRecord: "New Record",
    weight: "Weight",
    bodyFat: "Body Fat",
    muscleMass: "Muscle Mass",
    photos: "Photos",
    noRecords: "No records yet",
  },
  // Analytics
  analytics: {
    title: "Analytics & Insights",
    subtitle: "Visualize your evolution and achievements",
    exportCSV: "CSV",
    period: "Period",
    overview: "Overview",
    weightTab: "Weight",
    nutritionTab: "Nutrition",
    workoutsTab: "Workouts",
    moodTab: "Mood",
    noData: "No data to display",
    noDataDesc: "Start doing daily check-ins and tracking your progress to see detailed charts",
    noDataInPeriod: "No data in this period",
    viewAllHistory: "View all history",
  },
  // Auth
  auth: {
    login: "Log in",
    signup: "Sign up",
    email: "Email",
    password: "Password",
    fullName: "Full name",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    loginWithGoogle: "Log in with Google",
    welcomeTitle: "Welcome to FitPro",
    welcomeSubtitle: "Your fitness journey starts here",
    signinTab: "Log in",
    signupTab: "Sign Up",
    continueWithGoogle: "Continue with Google",
    signingIn: "Signing in...",
    creatingAccount: "Creating account...",
    createAccount: "Create Account",
    accountCreated: "Account created successfully!",
    accountCreatedDesc: "You can now log in.",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Enter password again",
    passwordsMatch: "Passwords match ✓",
    passwordsDontMatch: "Passwords don't match",
    tooManyAttempts: "Too many attempts",
    tooManyAttemptsDesc: "Please wait a minute before trying again.",
    passwordsMismatch: "Passwords don't match",
    invalidChars: "Invalid characters detected",
    errorSignup: "Error creating account",
    errorSignin: "Error signing in",
    errorGoogleSignin: "Error signing in with Google",
    termsText: "By creating an account, you agree to the",
    termsLink: "Terms of Service",
    andThe: "and the",
    privacyLink: "Privacy Policy",
    errorSignout: "Error signing out",
  },
  // Profile
  profile: {
    shareTitle: "My Profile",
    saveImage: "Save Image",
    share: "Share",
    points: "Points",
    streak: "Streak",
    checkins: "Check-ins",
    imageSaved: "Image saved! 📸",
    imageSavedDesc: "Share on your social media!",
    imageError: "Error generating image",
    profileCopied: "Copied!",
    profileCopiedDesc: "Text copied to clipboard",
    myProfile: "My Profile",
    friends: "Friends",
    challenges: "Challenges",
    copyProfileLink: "Copy public profile link",
    linkCopied: "Link copied! 🔗",
    linkCopiedDesc: "Share your public profile",
    profileNotFound: "Profile not found",
    profileNotFoundDesc: "The friend code provided does not exist or is invalid.",
    goToHome: "Go to home",
    startYourJourney: "Start your journey too 🚀",
  },
  // Ranking
  ranking: {
    title: "Ranking",
    subtitle: "See who's on top",
    yourPosition: "Your position",
  },
  // Streak
  streak: {
    title: "Streak",
    startToday: "Start your streak today!",
    greatStart: "Great start! Keep going tomorrow!",
    onTrack: "You're on the right track!",
    amazing: "Amazing! Keep it up!",
    unstoppable: "You're unstoppable! 🔥",
    nextMilestone: "Next milestone",
    remaining: "remaining",
    master: "Master",
    advanced: "Advanced",
    intermediate: "Intermediate",
    beginner: "Beginner",
    start: "Start",
  },
  // Daily Checkin
  checkin: {
    dayRecord: "Daily Record",
    trackProgress: "Track and update your daily progress",
    meals: "Meals",
    breakfast: "Breakfast",
    lunch: "Lunch",
    snack: "Snack",
    dinner: "Dinner",
    mealsComplete: "{{count}}/{{total}} meals complete",
    workout: "Workout",
    weightOfDay: "Today's Weight",
    howAreYouFeeling: "How are you feeling?",
    dayNotes: "Day Notes",
    dayNotesPlaceholder: "How was your day? Any observations...",
    saveRecord: "Save Record",
    updateRecord: "Update Record",
    recordSaved: "Record saved!",
    recordSavedDesc: "Your daily progress has been updated successfully.",
    errorSaving: "Error saving",
    invalidWeight: "Invalid weight",
    invalidWeightDesc: "Weight must be between 20 and 500 kg",
    userNotAuth: "User not authenticated",
    moodGreat: "Great",
    moodGood: "Good",
    moodOkay: "Okay",
    moodBad: "Bad",
  },
  // Water Tracker
  water: {
    title: "Water Today",
    cupSize: "1 cup = 250ml",
    goal: "Goal: {{amount}}ml",
    add: "Add",
    exceeded: "You exceeded your goal by {{amount}}ml. Drinking too much water can be harmful.",
    cupsAboveGoal: "⚠️ {{count}} cups above goal",
    goalReached: "🎉 Goal reached!",
    cupsRemaining: "{{count}} cups remaining",
    removeGlass: "Remove a cup",
    errorSaving: "Error saving",
  },
  // Navbar
  navbar: {
    toggleTheme: "Toggle theme",
    switchToTheme: "Switch to {{theme}} theme",
    light: "light",
    dark: "dark",
    changeLanguage: "Change language",
    switchToEnglish: "Switch to English",
    switchToPortuguese: "Mudar para Português",
    rankingGamification: "Ranking & Gamification",
    helpCenter: "Help Center",
    settings: "Settings",
    settingsDesc: "Configure app reminders and notifications",
    signOut: "Sign out",
    startNow: "Start Now",
  },
  // Help
  help: {
    title: "Help Center",
    subtitle: "Get answers and learn how to use all features",
    interactiveTour: "Interactive Tour",
    interactiveTourDesc: "Review the step-by-step tutorial of all app features",
    viewTutorial: "View Tutorial",
    foundProblem: "Found a problem?",
    foundProblemDesc: "Report bugs or send suggestions directly via WhatsApp",
    reportBug: "Report Bug",
    allCategories: "All",
    faq: "Frequently Asked Questions",
    quickTips: "Quick Tips",
    categories: {
      checkin: "Check-in",
      hydration: "Hydration",
      nutrition: "Nutrition",
      macros: "Macros",
      workout: "Workout",
      aiCoach: "AI Coach",
      social: "Social",
      challenges: "Challenges",
      gamification: "Gamification",
      ranking: "Ranking",
      progress: "Progress",
      notifications: "Notifications",
    },
    faqItems: [
      { category: "checkin", question: "How do I do the daily check-in?", answer: "On the Dashboard, you'll find the Daily Check-in card. Click to record your weight, mood, whether you worked out, and which meals you had. Checking in every day helps maintain your streak and earn points!" },
      { category: "checkin", question: "What happens if I forget to check in?", answer: "Your consecutive day streak will be reset, but don't worry! You can start over anytime. Try creating a habit by checking in at the same time every day." },
      { category: "hydration", question: "How many cups of water should I drink per day?", answer: "We recommend 8 cups of water per day (about 2 liters). Use the water tracker on the Dashboard to keep track. Each cup recorded counts towards your weekly goal!" },
      { category: "nutrition", question: "How does the food photo analysis work?", answer: "In the Macros tab, click the camera button to take a photo of your meal. Our AI analyzes the image and automatically estimates calories and macronutrients. You can adjust values if needed." },
      { category: "nutrition", question: "Can I substitute foods in my meal plan?", answer: "Yes! For each meal in your plan, you can use the substitution button to find similar foods with comparable macros. The AI suggests healthy equivalent options." },
      { category: "nutrition", question: "How do I generate a personalized meal plan?", answer: "In the Nutrition tab, fill in your data (weight, goal, restrictions) and click 'Generate Meal Plan'. The AI creates a complete plan with all daily meals, respecting your preferences and dietary restrictions." },
      { category: "nutrition", question: "How do I edit my meal plan?", answer: "On the pinned plan, use the 'Edit Plan' button to request AI changes (like swapping a food or adjusting quantities), or use 'Manual Edit' to make direct changes to individual foods." },
      { category: "macros", question: "How do I track my meals and calories?", answer: "In the Macros tab, add meals manually with name, calories, and macros. You can also use the camera to analyze food photos, and the AI fills in values automatically." },
      { category: "macros", question: "What do the macronutrients (P, C, F) mean?", answer: "P = Protein, C = Carbohydrates, F = Fat. Each serves a function: protein aids muscle recovery, carbohydrates provide energy, and fats are essential for hormones and vitamin absorption." },
      { category: "workout", question: "How do I generate a personalized workout plan?", answer: "Go to the Workouts tab, choose the workout type (gym, calisthenics, home, or mixed), available time, and click 'Generate Plan'. The AI creates a workout based on your level, equipment, and goals." },
      { category: "workout", question: "How do I see exercise execution tips?", answer: "Each exercise in your plan has an info icon. Click it to see detailed instructions, muscles worked, and common mistakes to avoid." },
      { category: "workout", question: "Can I edit individual exercises in my plan?", answer: "Yes! Each exercise has an edit button. You can ask the AI to substitute with an equivalent exercise, change sets/reps, or make manual adjustments directly." },
      { category: "aiCoach", question: "How do I use the AI FitCoach?", answer: "Access the AI FitCoach chat from the 'More' menu in the bottom bar. You can ask questions about training, nutrition, supplements, and health. The coach responds based on your profile and goals." },
      { category: "aiCoach", question: "Is there a limit on AI usage?", answer: "Yes, each AI feature has a daily usage limit to ensure quality for everyone. The usage badge (e.g., 2/5) shows how many times you've used it and the daily limit." },
      { category: "social", question: "How do I add friends in the app?", answer: "In the Social tab, you can share your friend code or search for friends by their code. Accept friend requests to compete in challenges and compare progress!" },
      { category: "social", question: "How do friend challenges work?", answer: "You can create personalized challenges with friends: who works out more days, drinks more water, etc. The winner earns bonus gamification points!" },
      { category: "challenges", question: "How do weekly challenges work?", answer: "Every week new automatic challenges appear (e.g., 'Drink 56 cups of water', 'Do 5 check-ins'). Complete them to earn bonus points and level up faster!" },
      { category: "gamification", question: "How does the points and levels system work?", answer: "You earn points for actions like checking in, completing workouts, hitting water goals, etc. Accumulated points determine your level (tier). There are 10 levels, from 'Regretful Couch Potato' to 'Fitness Immortal'!" },
      { category: "gamification", question: "How do I rank up within my level?", answer: "Each level has 4 divisions (4 to 1). As you accumulate points, you rank up automatically. When you reach enough points, you advance to the next level!" },
      { category: "ranking", question: "How does the ranking work?", answer: "The ranking shows users with the most gamification points. Your position is updated automatically as you earn points. Compete with the community to reach the top!" },
      { category: "progress", question: "How do I track my weight evolution?", answer: "In the Progress tab, you see weight charts over time. Record your weight in the daily check-in or directly in the progress tab to see weekly and monthly trends." },
      { category: "progress", question: "What is the Progress Report?", answer: "The Report is an animated visual summary of your progress with check-in, weight, water, and workout statistics. You can share it as an image on social media to show your evolution!" },
      { category: "notifications", question: "How do I set up water and workout reminders?", answer: "Access Notification Settings from the 'More' menu. There you can enable/disable water, workout, and check-in reminders, and set start and end times for alerts." },
    ],
    tips: [
      "Check in every day to maintain your streak",
      "Drink a cup of water every 1-2 hours",
      "Use the camera to log meals quickly",
      "Check execution tips before each exercise",
      "Stay consistent to level up faster",
      "Weigh yourself at the same time for better accuracy",
      "Ask the AI FitCoach about training and diet questions",
      "Challenge friends to stay motivated!",
    ],
  },
  // Onboarding
  onboarding: {
    mainGoal: "What is your main goal?",
    mainGoalDesc: "Choose the focus of your journey",
    loseWeight: "Lose Weight",
    loseWeightDesc: "Burn fat and get defined",
    gainMass: "Build Muscle",
    gainMassDesc: "Hypertrophy and muscle gain",
    maintain: "Maintain",
    maintainDesc: "Keep your current weight and health",
    generalHealth: "General Health",
    generalHealthDesc: "Improve energy and well-being",
    aboutYou: "Tell us about yourself",
    aboutYouDesc: "Basic info to personalize your plan",
    age: "Age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    preferNotSay: "Prefer not to say",
    select: "Select",
    height: "Height (cm) - optional",
    currentWeight: "Current Weight (kg)",
    targetWeight: "Target Weight (kg) - optional",
    weightAndGoal: "Current weight and goal",
    weightAndGoalDesc: "Helps us calculate your needs",
    experienceLevel: "Experience level",
    experienceLevelDesc: "To adjust workout intensity",
    beginner: "Beginner",
    beginnerDesc: "Never trained or less than 6 months",
    intermediate: "Intermediate",
    intermediateDesc: "Training for 6 months - 2 years",
    advanced: "Advanced",
    advancedDesc: "Training for over 2 years",
    activityLevel: "Daily activity level",
    sedentary: "Sedentary",
    sedentaryDesc: "Desk job, little walking",
    moderate: "Moderate",
    moderateDesc: "Walk a lot, active work",
    active: "Active",
    activeDesc: "Very physically active daily",
    workoutAvailability: "Workout availability",
    workoutAvailabilityDesc: "When and how you can train",
    daysPerWeek: "Days per week",
    availableEquipment: "Available equipment",
    fullGym: "Full gym",
    homeDumbbells: "Home dumbbells",
    bands: "Resistance bands",
    bodyweight: "Bodyweight only",
    pullUpBar: "Pull-up bar",
    sleepRecovery: "Sleep and recovery",
    sleepRecoveryDesc: "Essential for your results",
    avgSleep: "Average sleep per night",
    lessThan5h: "Less than 5 hours",
    moreThan8h: "More than 8 hours",
    eating: "Eating habits",
    eatingDesc: "Your habits and dietary restrictions",
    mealsPerDay: "Meals per day",
    meals: "meals",
    allergies: "Food allergies",
    gluten: "Gluten",
    lactose: "Lactose",
    nuts: "Nuts/Peanuts",
    seafood: "Seafood",
    eggs: "Eggs",
    soy: "Soy",
    noAllergies: "No allergies",
    dietaryRestrictions: "Dietary restrictions",
    noRestrictions: "No restrictions",
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    biggestChallenge: "Your biggest challenge",
    biggestChallengeDesc: "What most prevents you from reaching your goals?",
    consistency: "Staying consistent",
    controlDiet: "Controlling diet",
    noTime: "Lack of time",
    motivation: "Motivation",
    dontKnow: "Don't know what to do",
    injuries: "Injuries/Pain",
    yourMotivation: "Your motivation",
    yourMotivationDesc: "What drives you to seek a healthier life?",
    healthLongevity: "Health and longevity",
    physicalAppearance: "Physical appearance",
    moreEnergy: "More daily energy",
    selfEsteem: "Self-esteem/Confidence",
    sportPerformance: "Sport performance",
    medicalRecommendation: "Medical recommendation",
    injuriesInfo: "Injuries and information",
    injuriesInfoDesc: "Tell us if there's anything we should consider",
    injuriesPlaceholder: "E.g.: I have a right knee problem...",
    additionalInfo: "Any additional notes?",
    additionalInfoPlaceholder: "Anything else we should know to personalize your plans?",
    finishSetup: "Finish and Start! 🚀",
    settingUp: "Setting up...",
    profileSetup: "Profile set up! 🎉",
    profileSetupDesc: "Your personalized journey starts now",
    errorSaving: "Error saving",
    ageValidation: "Age must be between 10 and 120 years",
    ageRange: "10 - 120 years",
    heightValidation: "Height must be between 50 and 280 cm",
    heightRange: "50 - 280 cm",
    weightValidation: "Weight must be between 20 and 350 kg",
    targetWeightValidation: "Target weight must be between 20 and 350 kg",
  },
  // Social
  social: {
    title: "Social",
    myProfile: "My Profile",
    friends: "Friends",
    challenges: "Challenges",
  },
  // Pricing
  pricing: {
    back: "Back",
    signOut: "Sign out",
    disconnected: "Disconnected",
    disconnectedDesc: "You have signed out.",
    unlockPotential: "Unlock full potential",
    transformBody: "Transform your body with",
    premium: "FitPro Premium",
    unlimitedAccess: "Unlimited access to AI coach, personalized plans, meal analysis and much more.",
    youArePremium: "You are Premium!",
    nextBilling: "Next billing",
    manageSubscription: "Manage Subscription",
    managing: "Opening...",
    monthly: "Monthly",
    yearly: "Yearly",
    savePercent: "Save {{percent}}%",
    perMonth: "/month",
    perYear: "/year",
    savingsOf: "Savings of",
    subscribe: "Subscribe {{cycle}}",
    processing: "Processing...",
    mostPopular: "Most Popular",
    yourPlan: "Your Plan",
    redirectToSignup: "You will be redirected to create an account",
    securePayment: "Secure payment via Stripe",
    cancelAnytime: "Cancel anytime",
    immediateAccess: "Immediate access",
    termsAgree: "By subscribing, you agree to our Terms of Service and Privacy Policy.",
    subscriptionSuccess: "Subscription completed! 🎉",
    subscriptionSuccessDesc: "Welcome to FitPro Premium! Enjoy all features.",
    checkoutCanceled: "Checkout canceled",
    checkoutCanceledDesc: "You can try again anytime.",
  },
  // Macros Calculator
  macros: {
    title: "Macros Calculator",
    subtitle: "Precise calorie and macronutrient calculation for your goal",
    focusWeightLoss: "Weight Loss Focus",
    focusMuscleGain: "Muscle Gain Focus",
    yourData: "Your Data",
    fillInfo: "Fill in your info to calculate",
    weight: "Weight (kg)",
    height: "Height (cm)",
    age: "Age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    activityLevel: "Activity Level",
    sedentary: "Sedentary (little or no exercise)",
    light: "Light (1-3 days/week)",
    moderate: "Moderate (3-5 days/week)",
    active: "Active (6-7 days/week)",
    veryActive: "Very Active (2x per day)",
    calculate: "Calculate",
    results: "Your Results",
    basedOnProfile: "Based on your profile and goal",
    bmr: "Basal Metabolic Rate (BMR)",
    tdee: "Total Daily Energy Expenditure (TDEE)",
    dailyGoal: "Daily Calorie Goal",
    forWeightLoss: "For weight loss",
    forMuscleGain: "For muscle gain",
    protein: "Protein",
    carbs: "Carbohydrates",
    fat: "Fats",
    tip: "Use these values as a baseline. Monitor your progress and adjust as needed.",
    awaitingCalc: "Awaiting calculation",
    fillDataToCalc: "Fill in your data and click calculate to see your results",
  },
  // Calorie Counter
  calories: {
    title: "Calorie Counter",
    add: "Add",
    registerMeal: "Register Meal",
    photoOrManual: "Take a photo or enter manually",
    photoAI: "Photo AI",
    manual: "Manual",
    uploading: "Uploading...",
    clickToPhoto: "Click to take a photo or select an image",
    mealPhoto: "Meal photo",
    additionalInfo: "Additional info (optional)",
    additionalInfoPlaceholder: "E.g.: It's 200g of chicken with rice...",
    analyzeAndSave: "Analyze and Save",
    analyzing: "Analyzing...",
    changePhoto: "Change photo",
    mealName: "Meal name",
    caloriesLabel: "Calories",
    proteinG: "Protein (g)",
    carbsG: "Carbs (g)",
    fatG: "Fat (g)",
    notes: "Notes",
    notesPlaceholder: "Notes about the meal...",
    saveMeal: "Save Meal",
    saving: "Saving...",
    today: "Today",
    noEntries: "No meals recorded today",
    noEntriesDesc: "Add your first meal of the day",
    mealRegistered: "Meal registered!",
    entryRemoved: "Entry removed",
    entryRemovedDesc: "The meal was removed successfully",
    requiredFields: "Required fields",
    requiredFieldsDesc: "Meal name and calories are required",
    errorLoading: "Error loading entries",
    invalidFile: "Invalid file",
    selectImage: "Please select an image",
    errorUpload: "Error uploading",
    errorRemoving: "Error removing",
    userNotAuth: "User not authenticated",
  },
  // Gamification
  gamification: {
    yourProgress: "Your Progress",
    points: "points",
    forNext: "for",
    inRanking: "in Ranking",
    remaining: "Remaining",
    yourJourney: "Your Fitness Journey",
    yourPositionIn: "Your Position in",
    firstInTier: "You're the first in this tier!",
    tierLadder: "Tier Ladder",
    division: "Division",
    youAreHere: "You are here",
    conquered: "Conquered ✓",
    needPoints: "Need",
    user: "User",
    you: "you",
  },
  // Progress page
  progressPage: {
    title: "Progress Tracking",
    subtitle: "Track your evolution over time",
    addRecord: "Add Record",
    newRecord: "New Progress Record",
    newRecordDesc: "Record your measurements and track your evolution",
    weightKg: "Weight (kg)",
    bodyFatPercent: "Body Fat (%)",
    muscleMassKg: "Muscle Mass (kg)",
    observations: "Observations",
    observationsPlaceholder: "How are you feeling? Notes about training, nutrition...",
    photos: "Photos (max 3)",
    photo: "Photo",
    saveRecord: "Save Record",
    saving: "Saving...",
    progressSaved: "Progress recorded! 📊",
    dataSaved: "Your data has been saved successfully",
    noRecords: "No records yet",
    noRecordsDesc: "Start recording your progress to track your physical evolution over time",
    addFirstRecord: "Add First Record",
    invalidValue: "Invalid value",
    weightRange: "Weight must be between 0.1 kg and 500 kg",
    bodyFatRange: "Body fat must be between 0% and 60%",
    muscleMassRange: "Muscle mass must be between 0.1 kg and 300 kg",
    errorSaving: "Error saving",
    weight: "Weight",
    bodyFat: "% Body Fat",
    muscleMass: "Muscle Mass",
    fileTooLarge: "File too large",
    maxSize: "Maximum 5MB",
  },
  // Workouts page
  workoutsPage: {
    title: "Personalized Workouts",
    subtitle: "AI-generated workouts adapted to your goal",
    generateNew: "Generate New Workout",
    generateNewDesc: "Our AI will create a personalized plan based on your focus",
    planNameLabel: "Plan name (optional)",
    planNamePlaceholder: "E.g.: Push Pull Legs, Strength Training...",
    planNameHint: "If left empty, AI will generate a name automatically",
    descriptionLabel: "Describe what you're looking for in your workout (optional)",
    descriptionPlaceholder: "E.g.: I want more leg-focused exercises, or lighter exercises to start...",
    descriptionHint: "Optional: AI will adapt the workout to your reality",
    trainingType: "Training type",
    selectType: "Select type...",
    gym: "Gym (with machines)",
    calisthenics: "Calisthenics (bodyweight)",
    mixed: "Mixed (gym + calisthenics)",
    home: "At home (minimal equipment)",
    availableTime: "Available time (optional)",
    howLong: "How long?",
    min30: "30 minutes",
    min45: "45 minutes",
    hour1: "1 hour",
    hour1_30: "1h30",
    hour2: "2 hours",
    weightRequired: "Weight required",
    weightRequiredDesc: "Please enter your current weight.",
    invalidWeight: "Invalid weight",
    invalidWeightDesc: "Weight must be between 0.1 and 500kg.",
    invalidBodyFat: "Invalid body fat",
    invalidBodyFatDesc: "Body fat must be between 3% and 60%.",
    generating: "Generating Workout...",
    generatePlan: "Generate Workout Plan",
    workoutGenerated: "Workout Generated! 💪",
    workoutGeneratedDesc: "Your personalized workout plan is ready.",
    noPlans: "No workouts generated yet",
    noPlansDesc: "Fill in your data above and click 'Generate Workout Plan' to create your first personalized AI workout",
    active: "Active",
    planActivated: "Plan Activated!",
    planActivatedDesc: "This is now your active workout plan.",
    planDeleted: "Plan Deleted!",
    planDeletedDesc: "The workout plan was removed successfully.",
    errorDeleting: "Error deleting",
    rest: "Rest",
    days: "days",
    pinPlan: "Pin plan",
    unpinPlan: "Unpin plan",
    deletePlan: "Delete plan",
    weightLoss: "Weight Loss",
    muscleGain: "Muscle Gain",
  },
  // Analytics page
  analyticsPage: {
    title: "Analytics & Insights",
    subtitle: "Visualize your evolution and achievements",
    period: "Period:",
    selectPeriod: "Select period",
    dataSince: "Data since:",
    startDate: "Start date",
    endDate: "End date",
    to: "to",
    last7days: "Last 7 days",
    last14days: "Last 14 days",
    lastMonth: "Last month",
    last3months: "Last 3 months",
    last6months: "Last 6 months",
    lastYear: "Last year",
    thisYear: "This year",
    allHistory: "All history",
    custom: "Custom",
    checkins: "Check-ins",
    avgWater: "Avg Water",
    cups: "cups",
    avgCalories: "Avg Calories",
    currentWeight: "Current Weight",
    mealPlans: "Meal Plans",
    workoutPlans: "Workout Plans",
    noData: "No data to display",
    noDataDesc: "Start doing daily check-ins and recording your progress to see detailed charts",
    noDataInPeriod: "No data in this period",
    noDataInPeriodDesc: "There are no records in the selected period. Try expanding the date range.",
    viewAllHistory: "View all history",
    overview: "Overview",
    weightTab: "Weight",
    waterTab: "Water",
    caloriesTab: "Calories",
    moodTab: "Mood",
    hydration: "Hydration",
    workoutFrequency: "Workout Frequency",
    moodDistribution: "Mood Distribution",
    weightEvolution: "Weight Evolution",
    weightOverTime: "Track your weight variation over time",
    bodyComposition: "Body Composition",
    fatPercent: "% Fat",
    massKg: "Mass (kg)",
    calorieIntake: "Calorie Intake",
    dailyCalories: "Calories consumed per day",
    macroBreakdown: "Macro Breakdown",
    avgMacros: "Average macronutrients in the period",
    avgProtein: "Avg Protein",
    avgCarbs: "Avg Carbs",
    avgFat: "Avg Fat",
    moodOverTime: "Mood Over Time",
    moodTrend: "Your mood trend in check-ins",
    trained: "Trained",
    goal: "Goal",
  },
  // Landing page (Index)
  landing: {
    badge: "+10,000 users transforming their bodies",
    headline1: "Your Personal Trainer",
    headline2: "with AI.",
    headline3: "In your pocket",
    headline4: "24/7",
    subheadline: "100% personalized workout and meal plans, addictive gamification, and an AI coach always available.",
    startNow: "Start Now",
    goToDashboard: "Go to Dashboard",
    seeHowItWorks: "See how it works",
    rating: "4.9/5 • 2,400+ reviews",
    painTitle: "Stop wasting time on what",
    painTitleFaded: "doesn't work",
    painSubtitle: "See how FitPro solves each problem",
    featuresTitle: "Everything you need.",
    featuresTitleHighlight: "Nothing you don't.",
    featuresSubtitle: "Click to explore each feature",
    stepsTitle: "3 steps.",
    stepsTitleFaded: "Zero hassle.",
    testimonialsTitle: "Stories of",
    testimonialsTitleHighlight: "transformation",
    testimonialsSubtitle: "Real results from real people",
    tiersTitle: "How far will you go?",
    tiersSubtitle: "10 tiers to conquer. From couch potato to immortal.",
    tiersPointsLabel: "pts",
    ctaTitle: "Ready to",
    ctaTitleHighlight: "transform your body?",
    ctaSubtitle: "Join +10,000 people already using AI to achieve real results.",
    ctaButton: "Start Now — It's Free",
    faqTitle: "Frequently",
    faqTitleHighlight: "asked questions",
    footerDesc: "Transform your body with artificial intelligence.",
    footerProduct: "Product",
    footerLegal: "Legal",
    footerTerms: "Terms of Service",
    footerPrivacy: "Privacy Policy",
    footerRights: "All rights reserved.",
    features_ai: "AI that learns from you",
    features_ai_desc: "Workout and meal plans that evolve with your body and goals.",
    features_photo: "Photo → Calories",
    features_photo_desc: "Take a photo of your meal and get instant nutritional analysis.",
    features_gamification: "Gamification & Rankings",
    features_gamification_desc: "Rise from 'Regretful Couch Potato' to 'Fitness Immortal' with points and ranks.",
    features_challenges: "1v1 Challenges",
    features_challenges_desc: "Challenge friends in fitness battles and prove who's more dedicated.",
    features_analytics: "Full Analytics",
    features_analytics_desc: "Detailed charts of weight, calories, workouts and progress over time.",
    features_coach: "FitPro Coach 24/7",
    features_coach_desc: "Chat with your AI coach anytime. Ask questions, request plan adjustments.",
    features_ai_tag1: "Personalized plan",
    features_ai_tag2: "Adapts to progress",
    features_ai_tag3: "Learns your habits",
    features_challenge_you: "You",
    features_challenge_weekWorkouts: "Weekly workouts",
    extraWrapped: "Monthly wrapped",
    extraPWA: "Install as app (PWA)",
    extraGoals: "Personalized goals",
    extraSubstitutions: "Smart substitutions",
    step1Title: "Complete onboarding",
    step1Desc: "2 minutes to set up your profile, goals and restrictions.",
    step2Title: "Get your plan",
    step2Desc: "AI generates 100% personalized workout and meal plans.",
    step3Title: "Train and climb the ranking",
    step3Desc: "Execute, track, earn points and conquer tiers.",
    faqItems: [
      { q: "What is FitPro AI?", a: "It's a health and fitness app that uses artificial intelligence to create 100% personalized workout and meal plans, with gamification, social challenges and a virtual coach available 24/7." },
      { q: "How does the AI personalize my plans?", a: "During onboarding, you provide your data (weight, height, goals, restrictions). The AI uses this information to generate unique plans that adapt to your progress." },
      { q: "Can I cancel anytime?", a: "Yes! No contracts or commitments. Cancel whenever you want through the subscription management portal." },
      { q: "Does it work on iPhone and Android?", a: "Yes! FitPro AI is a PWA that works on any device — iPhone, Android and Desktop. Install directly from the browser." },
      { q: "Do I need gym experience?", a: "No! The app adapts to your level, from beginner to advanced." },
      { q: "How does gamification work?", a: "You earn points for every action (workouts, check-ins, goals). As you accumulate points, you level up — from 'Regretful Couch Potato' to 'Fitness Immortal'." },
    ],
    painPoints: [
      { pain: "Generic diets that don't work", solution: "AI-personalized meal plans" },
      { pain: "Workouts with no direction or purpose", solution: "Workouts adapted to your level and goal" },
      { pain: "Lack of motivation and consistency", solution: "Gamification, streaks and social challenges" },
      { pain: "Expensive personal trainer with fixed schedule", solution: "AI coach available 24/7 for $5.99/month" },
    ],
    testimonials: [
      { name: "Carlos S.", result: "Lost 15kg in 4 months", content: "FitPro changed my life! The AI truly understands my needs and creates plans that really work.", rating: 5 },
      { name: "Ana Paula M.", result: "Gained 8kg of muscle mass", content: "I never thought I'd get results so fast. The workouts are perfect for my level.", rating: 5 },
      { name: "Roberto C.", result: "Maintained shape for 6 months", content: "Even with little time, I can follow the routine. The gamification is addictive!", rating: 5 },
      { name: "Juliana F.", result: "Lost 10kg post-pregnancy", content: "The chat with the coach helped me a lot on tough days. It's like having a personal trainer available 24h.", rating: 5 },
    ],
    tiers: [
      { name: "Regretful Couch Potato", emoji: "🛋️", points: 0 },
      { name: "Motivated Beginner", emoji: "🌱", points: 100 },
      { name: "Couch Warrior", emoji: "⚔️", points: 300 },
      { name: "Weekend Athlete", emoji: "🏃", points: 600 },
      { name: "Gym Rat", emoji: "🐀", points: 1000 },
      { name: "Training Machine", emoji: "🤖", points: 1500 },
      { name: "Fitness Titan", emoji: "💪", points: 2200 },
      { name: "Living Legend", emoji: "🌟", points: 3000 },
      { name: "Demigod", emoji: "⚡", points: 4000 },
      { name: "Fitness Immortal", emoji: "👑", points: 5500 },
    ],
    coachQuestion: "How to adjust my workout for hypertrophy?",
    coachAnswer: "Based on your profile, I recommend 4 sets of 8-12 reps with progressive overload... 💪",
  },
};